import api from "../api/api";
import { appState, dispatch } from "../redux/redux-config";

function mapFamilyItem(item) {
    const first = (item?.firstName || "").trim();
    const last = (item?.lastName || "").trim();
    const fullName = [first, last].filter(Boolean).join(" ").trim();

    return {
        id: Number(item?.familyDUID ?? 0),
        name: fullName || item?.mailingName || "Unnamed Family",
        _pickerType: "family",
        familyDUID: item?.familyDUID,
        mailingName: item?.mailingName,
        firstName: item?.firstName,
        lastName: item?.lastName,
        emailAddress: item?.eMailAddress,
        familyHomePhone: item?.familyHomePhone,
        primaryPhone: item?.primaryPhone,
        totalResults: item?.totalResults,
        doNotCall: item?.doNotCall,
    };
}

const family = {

    initPage: function () {
    },

    load: async (search, page, pageSize, skipTotal) => {
        const parishSoftToken = localStorage.getItem("ParishSoftToken") || "";
        const result = await api.parishSoft.getFamilyList(
            parishSoftToken,
            search,
            page,
            pageSize,
            skipTotal
        );

        if (result?.success) {
            const mappedList = Array.isArray(result?.list)
                ? result.list.map(mapFamilyItem)
                : [];
            const totalCount =
                typeof result?.totalCount === "number"
                    ? result.totalCount
                    : mappedList[0]?.totalResults || 0;

            dispatch({
                type: "GROUPS_LOADED",
                payload: {
                    list: mappedList,
                    totalCount,
                },
            });
            return {
                success: true,
                list: mappedList,
                totalCount,
            };
        }

        // On failure, return a consistent shape to prevent UI crashes
        return {
            success: false,
            list: [],
            totalCount: 0,
            errorMessage: result?.errorMessage || "Failed to load families.",
        };
    },

    save: async function (group) {
        let token = appState().user.token;
        let result = await api.groups.save(token, group);
        if (result.success) return result;
    },

};
export default family;

export function groupsReducer(state, action) {
    if (state === undefined) return initialState;

    switch (action.type) {
        case "GROUP_SETTINGS_UPDATE":
            return {
                ...state,
                ...action.payload,
            };

        case "GROUP_LIST_CHANGED":
            return {
                ...state,
                groupOptions: null,
            };

        case "GROUPS_LOADED":
            return {
                ...state,
                groups: action.payload.list,
                totalCount: action.payload.totalCount,
            };

        case "LOGOUT":
            return initialState;

        default:
            return state;
    }
}
const initialState = {
    sync: {},
    groups: [],
    totalCount: 0,
};
